import React from "react";
import DashboardLayout from "../../components/universal/dashboard-layout";
import DashboardLeftNavigation from "../../components/universal/dashboard-left-navigation";
import DashboardUpperNavigation from "../../components/universal/dashboard-upper-navigation";
import DashboardClients from "../../components/dashboard/clients";

const Index = () => {
  return (
    <DashboardLayout
      DashboardLeftNavigation={() => <DashboardLeftNavigation />}
      DashboardUpperNavigation={() => <DashboardUpperNavigation />}
      DashboardContent={() => <DashboardClients />}
    />
  );
};

export default Index;
